import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';

export const HeroBottomGradient = () => (
  <LinearGradient
    pointerEvents="none"
    colors={['transparent', '#803F20']}
    start={{ x: 0.5, y: 0 }}
    end={{ x: 0.5, y: 1 }}
    style={heroBottomGradientStyles.fill}
  />
);

export const heroBottomGradientStyles = StyleSheet.create({
  fill: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    height: 75,
    width: '100%',
  },
});
